import { gql } from '@apollo/client';

const DELETE_ACCOUNT_APPLICATION = gql`
mutation deleteApplication($companyId:Int!, $id:Int!)
{
	companyAdminContext{
		users{
			deleteAccountApplication(companyId:$companyId, id:$id)
		}
	}	
}
`;

export default DELETE_ACCOUNT_APPLICATION;
